import React from 'react';
import './home-page-btn.scss'

const HomePageBtn = ({onClick}) => {
  return (
    <button type="button" onClick={onClick} className='home-page-btn'>Назад</button>
  );
};

export default HomePageBtn;